import { SETTINGS_DEV } from './settings.dev';
import { SETTINGS_PROD } from './settings.prod';
import { SETTINGS_STAGING } from './settings.staging';

export const ENV_DEV = 'dev';
export const ENV_STAGING = 'staging';
export const ENV_PROD = 'prod';

// REACT_APP_ENV is injected at build time by the npm scripts (see package.json).
// NODE_ENV is a built-in create-react-app variable that you CANNOT override manually:
// 'npm start' => 'development', 'npm test' => 'test', 'npm run build' => 'production'
// https://create-react-app.dev/docs/adding-custom-environment-variables/
// eslint-disable-next-line no-undef
const APP_ENV = process.env.REACT_APP_ENV || (process.env.NODE_ENV === 'development' ? ENV_DEV : ENV_PROD);

const ENV_SETTINGS = {
  [ENV_DEV]: SETTINGS_DEV,
  [ENV_STAGING]: SETTINGS_STAGING,
  [ENV_PROD]: SETTINGS_PROD,
};

// These settings are common between dev, staging and prod
// These settings can be overwritten by having the same key in an env settings file
const commonSettings = {
  APP_ENV: APP_ENV,

  // Displays the devMessages even outside of dev
  TRACE_MODE: false,

  // Displays "MAX=X" on the P3 InputNumber of participants
  TRACE_VARIANT_MAX_PLACES: false,

  // Displays the stock information on the P3 options select (if applicable)
  TRACE_VARIANT_MAX_STOCK: false,

  // N days after its creation date, the cart will expire
  // This settings might be overriden in dev settings for test purposes
  CART_DAYS_EXPIRATION: 13,

  // Max number of voucher we can buy at once
  VOUCHER_BUY_LIMIT: 100,

  // Max number of participants when we set the qty on P3
  PARTICIPANTS_QTY_LIMIT: 100,

  IMAGE_SLIDER_DELAY_MS: 3000,

  ROLLBAR_TOKEN: 'acf8ad943ebf46af9b9f0046ad9efbf2',

  GTM_ID_VAKARIO: 'GTM-KXNJ2TL',
};

const envSettings = ENV_SETTINGS[APP_ENV];
if (envSettings == null) throw new Error(`Unknown REACT_APP_ENV "${APP_ENV}", expected one of: ${Object.keys(ENV_SETTINGS).join(', ')}`);

// This is the global constant that can be used to read settings
export const settings = Object.assign({}, commonSettings, envSettings);

// using devError() will alert in DEV and warn in STAGING/PROD, useful to remind us for stuff when dev
export const devError = msg => {
  if (settings.IS_DEV) {
    alert(msg);
    console.error(msg);
  } else console.warn(msg);
};

// using devMessage() will log to console if conditions met, useful for development/debug
export const devMessage =
  settings.IS_DEV || settings.TRACE_MODE ? console.log.bind(window.console, '%c[devMessage]', 'color: green') : function () {};
devMessage('App loaded with settings:', settings);
